// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DcAF","footer":"styles_footer__2n67b"};